import React from 'react';
import PropTypes from 'prop-types';
import Styling from 'components/AuthStyling';
import Button from 'components/Button';

import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';

const SuccessMessage = ({ history }) => {
  const { t } = useTranslation();
  const fullMessage = [
    t('A verification link was sent to'),
    `${history.location.state?.email}.`,
    t('Please check your email to complete verification.'),
  ];
  const login = () => {
    history.push('/login');
  };

  const resend = () => {
    history.push('/pwd-recover');
  };

  return (
    <Styling>
      <div className={styles.formArea}>
        {fullMessage.map((item, index) => (
          <p className={styles.welcomeMessage} key={index}>
            {item}
          </p>
        ))}
      </div>

      <div className={styles.successButtonRow}>
        <Button
          text={t('Resend')}
          onClick={resend}
          type="button"
          color="secondary"
          theme="light"
        />
        <Button text={t('Log In')} onClick={login} type="button" />
      </div>
    </Styling>
  );
};

SuccessMessage.propTypes = {
  history: PropTypes.object.isRequired,
};

export default SuccessMessage;
